import React, { FunctionComponent } from 'react';
import { CLOSE_PATHS, CLOSE_VIEWBOX } from '../../../svg/paths/close';
import classnames from 'classnames';

type Props = {
  isModalOpen: boolean;
  onClose: () => void;
};

export const Presentation: FunctionComponent<Props> = ({
  isModalOpen,
  onClose,
}) => {
  return (
    <div className={classnames('plan-billing-change__modal-overlay', { 'plan-billing-change__modal-overlay--active': isModalOpen })} onClick={onClose}>
      <div className={classnames('plan-billing-change__modal', 'plan-billing-change__modal--wide', {
        'plan-billing-change__modal--active': isModalOpen
      })} onClick={(e) => e.stopPropagation()}>
        {/* ヘッダー */}
        <div className="plan-billing-change__modal-header">
          <div className="plan-billing-change__modal-title">
            <p className="plan-billing-change__modal-title-text">プランアップグレード</p>
          </div>
          <button className="plan-billing-change__modal-close-button" onClick={onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12">
              <path
                d="M0.735395 12L0 11.2646L5.26461 6L0 0.735394L0.735395 0L6 5.26461L11.2646 0L12 0.735394L6.7354 6L12 11.2646L11.2646 12L6 6.73539L0.735395 12Z"
                fill="#19190F"
              />
            </svg>
          </button>
        </div>

        {/* メインコンテンツ */}
        <div className="plan-billing-change__modal-main">
          <div className="plan-billing-change__modal-contents">
            {/* 各プランの特徴 */}
            <div className="plan-billing-change__modal-section">
              <p className="plan-billing-change__modal-section-title">機能を利用するにはプランをアップグレードする必要があります</p>
              <p className="plan-billing-change__modal-section-description">
                プランをアップグレードすることで、選択したプランに応じた機能が利用可能になります。<br />
                詳細はプランページからもご確認いただけます。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
